import React, { useState, useEffect, useRef, forwardRef } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import Slider from "react-slick";
import 'react-datepicker/dist/react-datepicker.css';
import Select from 'react-select';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import RecentGallery from './components/RecentGallery';
import { fetchAirports, fetchPackages, fetchCountries, fetchHotelCities, fetchHotelsByCity, fetchHotelAvailability } from './api/apiService';
import flightIcon from './assets/images/flights.png';
import activeFlightIcon from './assets/images/active-flight.png';
import PackageBooking from "./pages/PackageBooking";
import hotelIcon from './assets/images/hotels.png';
import activeHotelIcon from './assets/images/active-hotels.png';

import holidayIcon from './assets/images/holiday.png';
import activeHolidayIcon from './assets/images/active-holiday.png';

import Header from './components/PackagesHeader';
import Footer from './components/Footer';
import Gallery from "./pages/Gallery";
import AboutUs from './pages/AboutUs';
import Packages from './pages/Packages';
import PackageDetails from './pages/PackageDetails';
import Flights from './pages/Flights';
import HotelResults from "./pages/HotelResults";
import BookingPage from "./pages/BookingPage";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Profile from "./pages/Profile";
import Contact from "./pages/Contact";
import Booking from "./pages/Booking";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import UserAgreement from "./pages/UserAgreement";

import axios from "axios";
import ProtectedRoute from "./components/ProtectedRoute";
import bgImage from './assets/images/newbg.png';

import { FaClock } from 'react-icons/fa';
import { FaCalendarAlt } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

import { fetchFlights } from "../src/pages/Flights";

function Home() {
  const [packages, setPackages] = useState([]);
  const [activeTab, setActiveTab] = useState('holiday');
  const [airportOptions, setAirportOptions] = useState([]);
const [selectedCountry, setSelectedCountry] = useState('');
  const [tripType, setTripType] = useState('oneway');
  const [fromCity, setFromCity] = useState('');
  const [toCity, setToCity] = useState('');
  const [countryOptions, setCountryOptions] = useState([]);
  const [departureDate, setDepartureDate] = useState(null);
  const [returnDate, setReturnDate] = useState(null);
  const [travelers, setTravelers] = useState(1);
  const [travelClass, setTravelClass] = useState('All');
  
  const [selectedCity, setSelectedCity] = useState('');
  const [selectedMonth, setSelectedMonth] = useState('');
  const [location, setLocation] = useState('');
  const [checkIn, setCheckIn] = useState('');
  const [checkOut, setCheckOut] = useState('');
   const [hotelName, setHotelName] = useState('');
   const [hotels, setHotels] = useState([]);
    const [cities, setCities] = useState([]);
    const [logos, setLogos] = useState([]);

  
  const [rooms, setRooms] = useState([
    { adults: 2, children: 2, childAges: [8, 6] }
  ]);
const [Info, setInfo] = useState({
    info_text: "",
    
  });
useEffect(() => {
  axios.get("https://online.funforay.com/admin/public/api/logos")
    .then((res) => {
      console.log("API RESPONSE:", res.data); // 👈 ADD THIS

      if (res.data.status) {
        setLogos(res.data.data);
      }
    })
    .catch((err) => {
      console.log("API ERROR:", err);
    });
}, []);
 
   useEffect(() => {
      fetch("https://online.funforay.com/admin/api/settings")
        .then((res) => res.json())
        .then((data) => {
          if (data.success && data.data) {
            setInfo({
              info_text: data.data.info_text,
            
            });
          }
        })
        .catch(() => console.log("Failed to load contact info"));
    }, []);
   
  const [showRoomSelector, setShowRoomSelector] = useState(false);

    const handleAddRoom = () => {
    setRooms([...rooms, { adults: 2, children: 0, childAges: [] }]);
  };

  const handleRoomChange = (index, field, value) => {
    const updatedRooms = [...rooms];
    if (field === 'adults' || field === 'children') {
      updatedRooms[index][field] = parseInt(value);
      if (field === 'children') {
        updatedRooms[index].childAges = Array(parseInt(value)).fill(4);
      }
    }
    setRooms(updatedRooms);
  };

  const handleChildAgeChange = (roomIndex, ageIndex, value) => {
    const updatedRooms = [...rooms];
    updatedRooms[roomIndex].childAges[ageIndex] = parseInt(value);
    setRooms(updatedRooms);
  };

  const totalGuests = rooms.reduce(
    (acc, room) => acc + room.adults + room.children,
    0
  );



 const handlehotelSubmit = async (e) => {
    e.preventDefault();
    if (!location || !checkIn || !checkOut) return alert("Please select city and dates");

    // Step 1a: Fetch all hotels codes for the selected city
    const hotels = await fetchHotelsByCity(location);
    if (!hotels.length) return alert("No hotels found for this city");

    const hotelCodes = hotels.map((h) => h.code).join(",");

    // Step 1b: Build payload
    const totalAdults = rooms.reduce((sum, r) => sum + Number(r.adults), 0);
    const totalChildren = rooms.reduce((sum, r) => sum + Number(r.children), 0);

    const payload = {
      CheckIn: checkIn,
      CheckOut: checkOut,
      HotelCodes: hotelCodes,
      GuestNationality: "IN",
      PaxRooms: rooms.map((r) => ({
        Adults: r.adults,
        Children: r.children,
        ChildrenAges: r.childAges.length ? r.childAges : null,
      })),
      ResponseTime: 23,
      IsDetailedResponse: true,
      Filters: {
        Refundable: false,
        NoOfRooms: 0, // get all rooms
        MealType: 0,
        StarRating: 0,
      },
    };

    // Step 1c: Redirect to hotel-result page with payload
    navigate("/hotel-result", { state: { payload } });
  };



  
const cabinClassMap = {

  economy: 2,
  premiumeconomy: 3,
  business: 4,
  premiumbusiness: 5,
  first: 6
};

  const dropdownRef = useRef(null);
  const CustomDateInput = forwardRef(({ value, onClick }, ref) => (
    <div className="custom-date-picker" onClick={onClick} ref={ref} style={{ position: 'relative', cursor: 'pointer' }}>
      <input
        className="input-design_input"
        value={value}
        readOnly
        placeholder="Departure Date"
        style={{ width: '100%' }}
      />
      <FaCalendarAlt className='calender'

      />
    </div>
  ));


const [adults, setAdults] = useState(1);
const [children, setChildren] = useState(0);
const [infants, setInfants] = useState(0);
const [directFlight, setDirectFlight] = useState(false);
const [oneStopFlight, setOneStopFlight] = useState(false);


const [multiCitySegments, setMultiCitySegments] = useState([]);
const [showTravelDropdown, setShowTravelDropdown] = useState(false); // for non-multicity
const travelClassLabel = {
  '2': 'Economy',
  '3': 'Premium Economy',
  '4': 'Business',
  '5': 'Premium Business',
  '6': 'First Class',

  economy: 'Economy',
  premiumeconomy: 'Premium Economy',
  business: 'Business',
  premiumbusiness: 'Premium Business',
  first: 'First Class'
};
const toggleDropdown = (index) => {
  setMultiCitySegments(prev =>
    prev.map((seg, i) => ({
      ...seg,
      showDropdown: i === index ? !seg.showDropdown : false
    }))
  );
};

const handleAddSegment = () => {
  setMultiCitySegments(prev => [
    ...prev,
    {
      from: '',
      to: '',
      departureDate: null,
      returnDate: null,
      adults: 1,
      children: 0,  // add this
      infants: 0,   // add this
      travelClass: 'economy',
      showDropdown: false
    }
  ]);
};

const handleRemoveSegment = (index) => {
  setMultiCitySegments(prev => prev.filter((_, i) => i !== index));
};

const formatAirportOption = (option) => (
  <div>
    <div style={{ fontWeight: 'bold', color: '#006CB8', fontSize: '24px' }}>{option.cityname}</div>
    <div style={{ fontSize: '12px', color: '#5F5F5F' }}>
      {option.airportcode} – {option.airportname}
    </div>
  </div>
);
const BACKEND_BASE_URL = process.env.REACT_APP_BACKEND_URL;



const navigate = useNavigate();

const handleFlightSubmit = async (e) => {
  e.preventDefault();

  let payload = {};

  if (tripType === "multicity") {
    payload.journey_type = 3;
    payload.cabin_class = cabinClassMap[multiCitySegments[0]?.travelClass?.toLowerCase()] || 2;

    payload.multi_origin = [];
    payload.multi_destination = [];
    payload.multi_departure_date = [];
      payload.adults = multiCitySegments[0]?.adults || 1;
  payload.children = multiCitySegments[0]?.children || 0;
  payload.infants = multiCitySegments[0]?.infants || 0;
    payload.direct_flight = true;
    multiCitySegments.forEach((segment) => {
      payload.multi_origin.push(segment.from);
      payload.multi_destination.push(segment.to);

      if (segment.departureDate) {
        const d = segment.departureDate;
        payload.multi_departure_date.push(
          `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`
        );
      }
    });
  } else {
    payload.origin = fromCity;
    payload.destination = toCity;
    payload.departure_date = departureDate
      ? `${departureDate.getFullYear()}-${String(departureDate.getMonth() + 1).padStart(2, "0")}-${String(departureDate.getDate()).padStart(2, "0")}`
      : "";

    if (tripType === "round trip") {
      payload.journey_type = 2;
      payload.arrival_date = returnDate
        ? `${returnDate.getFullYear()}-${String(returnDate.getMonth() + 1).padStart(2, "0")}-${String(returnDate.getDate()).padStart(2, "0")}`
        : "";
    } else {
      payload.journey_type = 1;
    }

    payload.cabin_class = cabinClassMap[travelClass.toLowerCase()] || 2;

    payload.adults = adults;
    payload.children = children;
    payload.infants = infants;
    payload.direct_flight = true;
  }

  // ✅ Redirect to Flights page with query params
  const queryString = new URLSearchParams(payload).toString();
navigate(`/flights?${queryString}`);

};




  // Reusable date input with calendar icon
  const CustomDateInputreturn = forwardRef(({ value, onClick, disabled }, ref) => (
    <div
      className="custom-date-picker"
      onClick={!disabled ? onClick : undefined}
      ref={ref}
      style={{
        position: 'relative',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.6 : 1
      }}
    >
      <input
        className="input-design_input"
        value={value}
        readOnly
        placeholder="Return Date"
        style={{ width: '100%' }}
        disabled={disabled}
      />
      <FaCalendarAlt className='calender'

      />
    </div>
  ));


  useEffect(() => {
    fetchAirports().then(setAirportOptions).catch(() => setAirportOptions([]));
    fetchPackages().then(setPackages).catch(console.error);
   fetchCountries().then(setCountryOptions).catch(() => setCountryOptions([]));

    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowTravelDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } }
    ]
  };

// Fetch cities on mount
useEffect(() => {
  const loadCities = async () => {
    const cityList = await fetchHotelCities("IN");
    setCities(cityList);
  };
  loadCities();
}, []);

// Fetch hotels when a city is selected
useEffect(() => {
  const loadHotels = async () => {
    if (!location) return;
    const hotelList = await fetchHotelsByCity(location); // location = cityCode
    setHotels(hotelList);
  };
  loadHotels();
}, [location]);




  const monthNameToNumber = {

    January: 0,
    February: 1,
    March: 2,
    April: 3,
    May: 4,
    June: 5,
    July: 6,
    August: 7,
    September: 8,
    October: 9,
    November: 10,
    December: 11,
  };
  const bannerStyle = {
    backgroundImage: `url(${bgImage})`,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    padding: '32px 20px 50px 20px',
    color: '#000',
    textAlign: 'center'
  };

  const tabButtonStyle = (tab) => ({
    padding: '10px 20px',
    border: 'none',
    borderRadius: '15px',

    backgroundColor: activeTab === tab ? '#E2068C' : '#fff',
    color: activeTab === tab ? '#fff' : '#E2068C',
    cursor: 'pointer',
    fontFamily: 'Manrope',
    fontSize: '15px',
    fontWeight: '700',
    borderRadius: '15px',
  });

const handleSearch = (e) => {
  e.preventDefault();

  if (!selectedCountry && !selectedMonth) return;

  let url = '/packages?';

  if (selectedCountry) {
    url += `country=${encodeURIComponent(selectedCountry)}&`;
  }

  if (selectedMonth) {
    url += `month=${selectedMonth}`;
  }

  navigate(url);
};
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log({ tripType, fromCity, toCity, departureDate, returnDate: tripType === 'round trip' ? returnDate : null, travelers, travelClass });
  };

  


  return (
    <main>
      <div style={bannerStyle}>
        {/* Tabs */}
        <div
          className="tabdesign"
          style={{ display: 'flex', gap: '20px', alignItems: 'center', marginBottom: '4px' }}
        >
          {[
            // { tab: 'flight', icon: flightIcon, activeIcon: activeFlightIcon, label: 'Flight' },
            // { tab: 'hotel', icon: hotelIcon, activeIcon: activeHotelIcon, label: 'Hotels' },
            { tab: 'holiday', icon: holidayIcon, activeIcon: activeHolidayIcon, label: 'Holiday Packages' }
          ].map(({ tab, icon, activeIcon, label }) => (
            <button
              key={tab}
              style={tabButtonStyle(tab)}
              onClick={() => setActiveTab(tab)}
            >
              <img
                src={activeTab === tab ? activeIcon : icon}
                alt={label}
                style={{ height: '15px', marginRight: '8px', verticalAlign: 'middle' }}
              />
              <span>{label}</span>
            </button>
          ))}
        </div>



        <div className="formmain">
          {activeTab === 'flight' && (
        <form className="form-design" onSubmit={handleFlightSubmit}>
  <div className="flight_design">
    {/* Trip Type Radio Buttons */}
    <div className="mb-4 radio_design">
      {['oneway', 'round trip', 'multicity'].map((type) => (
        <label key={type} className="mr-4">
          <input
            type="radio"
            name="tripType"
            value={type}
            checked={tripType === type}
            onChange={(e) => {
              setTripType(e.target.value);
              if (e.target.value === 'multicity') {
                setMultiCitySegments([
                  {
                    from: '',
                    to: '',
                    departureDate: null,
                    returnDate: null,
                    adults: 1,
                    children: 0,
                    infants: 0,
                    travelClass: 'economy',
                    showDropdown: false
                  }
                ]);
              }
            }}
          />{" "}
          {type.charAt(0).toUpperCase() + type.slice(1)}
        </label>
      ))}
    </div>

    {/* Multicity Mode */}
   {tripType === 'multicity' ? (
  <>
    {multiCitySegments.map((segment, index) => (
      <div key={index} className="flex multicity-row" style={{ marginBottom: '25px', position: 'relative' }}>
        {/* From */}
        <div className="select_input">
          <label>From</label>
          <Select
            className="input-design"
            options={airportOptions}
            value={airportOptions.find(opt => opt.value === segment.from)}
            onChange={(selected) => {
              const updated = [...multiCitySegments];
              updated[index].from = selected?.value || '';
              setMultiCitySegments(updated);
            }}
            placeholder="From"
            formatOptionLabel={formatAirportOption}
          />
        </div>

        {/* To */}
        <div className="select_input">
          <label>To</label>
          <Select
            className="input-design"
            options={airportOptions}
            value={airportOptions.find(opt => opt.value === segment.to)}
            onChange={(selected) => {
              const updated = [...multiCitySegments];
              updated[index].to = selected?.value || '';
              setMultiCitySegments(updated);
            }}
            placeholder="To"
            formatOptionLabel={formatAirportOption}
          />
        </div>

        {/* Departure */}
        <div className="select_input">
          <label>Departure</label>
          <DatePicker
            selected={segment.departureDate}
            onChange={(date) => {
              const updated = [...multiCitySegments];
              updated[index].departureDate = date;
              setMultiCitySegments(updated);
            }}
            dateFormat="dd MMM, yy"
            customInput={<CustomDateInput />}
          />
        </div>

        {/* Return */}
        {/* <div className="select_input">
          <label>Return</label>
          <DatePicker
            selected={segment.returnDate}
            onChange={(date) => {
              const updated = [...multiCitySegments];
              updated[index].returnDate = date;
              setMultiCitySegments(updated);
            }}
            dateFormat="dd MMM, yy"
            customInput={<CustomDateInputreturn />}
          />
        </div> */}

        {/* Travellers & Class — ONLY for first row (index === 0) */}
        {index === 0 && (
          <div className="select_input">
            <label>Travellers & Class</label>
            <div
              className="input-design_input"
              onClick={() => toggleDropdown(index)}
              style={{ cursor: 'pointer' }}
            >
              {segment.adults} Adults, {segment.children} Children, {segment.infants} Infants, {travelClassLabel[segment.travelClass]}
            </div>

            {segment.showDropdown && (
              <div style={{
                position: 'absolute',
                background: 'white',
                border: '1px solid #ccc',
                borderRadius: '5px',
                padding: '10px',
                zIndex: 10
              }}>
                <div style={{ marginBottom: '10px' }}>
                  <label>Adults</label>
                  <input
                    type="number"
                    min="1"
                    value={segment.adults}
                    onChange={(e) => {
                      const updated = [...multiCitySegments];
                      updated[index].adults = parseInt(e.target.value);
                      setMultiCitySegments(updated);
                    }}
                    className="input-design_input"
                  />
                </div>
                <div style={{ marginBottom: '10px' }}>
                  <label>Children</label>
                  <input
                    type="number"
                    min="0"
                    value={segment.children}
                    onChange={(e) => {
                      const updated = [...multiCitySegments];
                      updated[index].children = parseInt(e.target.value);
                      setMultiCitySegments(updated);
                    }}
                    className="input-design_input"
                  />
                </div>
                <div style={{ marginBottom: '10px' }}>
                  <label>Infants</label>
                  <input
                    type="number"
                    min="0"
                    value={segment.infants}
                    onChange={(e) => {
                      const updated = [...multiCitySegments];
                      updated[index].infants = parseInt(e.target.value);
                      setMultiCitySegments(updated);
                    }}
                    className="input-design_input"
                  />
                </div>
                <div>
                  <label>Class</label>
                  <select
                    value={segment.travelClass}
                    onChange={(e) => {
                      const updated = [...multiCitySegments];
                      updated[index].travelClass = e.target.value;
                      setMultiCitySegments(updated);
                    }}
                    className="input-design_input"
                  >
                    <option value="economy">Economy</option>
                    <option value="premiumeconomy">Premium Economy</option>
                    <option value="business">Business</option>
                    <option value="premiumbusiness">Premium Business</option>
                    <option value="first">First Class</option>
                  </select>
                </div>
              </div>
            )}
          </div>
        )}

        {/* Remove button */}
        {index > 0 && (
          <button
            type="button"
            onClick={() => handleRemoveSegment(index)}
            style={{ position: 'absolute', right: -25, top: 5 }}
          >
            ❌
          </button>
        )}
      </div>
    ))}

    {/* Add Segment Button */}
    <div style={{ marginBottom: '20px' }}>
      <button type="button" onClick={handleAddSegment} className="add-segment-btn">
        + Add City
      </button>
    </div>
  </>
) 
 : (
      // Oneway / Round-trip
      <div className="flex">
        <div className="select_input">
          <label>From</label>
          <Select
            className="input-design"
            options={airportOptions}
            value={airportOptions.find(opt => opt.value === fromCity)}
            onChange={(selected) => setFromCity(selected?.value || '')}
            placeholder="From"
            formatOptionLabel={formatAirportOption}
          />
        </div>

        <div className="select_input">
          <label>To</label>
          <Select
            className="input-design"
            options={airportOptions}
            value={airportOptions.find(opt => opt.value === toCity)}
            onChange={(selected) => setToCity(selected?.value || '')}
            placeholder="To"
            formatOptionLabel={formatAirportOption}
          />
        </div>

        <div className="select_input">
          <label>Departure</label>
          <DatePicker
            selected={departureDate}
            onChange={(date) => setDepartureDate(date)}
            dateFormat="dd MMM, yy"
            customInput={<CustomDateInput />}
          />
        </div>

        <div className="select_input">
          <label>Return</label>
          <DatePicker
            selected={returnDate}
            onChange={(date) => setReturnDate(date)}
            dateFormat="dd MMM, yy"
            customInput={<CustomDateInputreturn disabled={tripType !== 'round trip'} />}
            disabled={tripType !== 'round trip'}
          />
        </div>

        <div className="select_input" ref={dropdownRef}>
          <label>Travellers & Class</label>
          <div
            className="input-design_input"
            onClick={() => setShowTravelDropdown(!showTravelDropdown)}
            style={{ cursor: 'pointer' }}
          >
            {adults} Adults, {children} Children, {infants} Infants, {travelClassLabel[travelClass]}
          </div>

          {showTravelDropdown && (
            <div style={{
              position: 'absolute',
              background: 'white',
              border: '1px solid #ccc',
              borderRadius: '5px',
              padding: '10px',
              zIndex: 10
            }}>
              <div style={{ marginBottom: '10px' }}>
                <label>Adults</label>
                <input
                  type="number"
                  min="1"
                  value={adults}
                  onChange={(e) => setAdults(parseInt(e.target.value))}
                  className="input-design_input"
                />
              </div>
              <div style={{ marginBottom: '10px' }}>
                <label>Children</label>
                <input
                  type="number"
                  min="0"
                  value={children}
                  onChange={(e) => setChildren(parseInt(e.target.value))}
                  className="input-design_input"
                />
              </div>
              <div style={{ marginBottom: '10px' }}>
                <label>Infants</label>
                <input
                  type="number"
                  min="0"
                  value={infants}
                  onChange={(e) => setInfants(parseInt(e.target.value))}
                  className="input-design_input"
                />
              </div>
              <div>
                <label>Class</label>
                <select
                  value={travelClass}
                  onChange={(e) => setTravelClass(e.target.value)}
                  className="input-design_input"
                >
                
  <option value="economy">Economy</option>
  <option value="premiumeconomy">Premium Economy</option>
  <option value="business">Business</option>
  <option value="premiumbusiness">Premium Business</option>
  <option value="first">First Class</option>
                </select>
              </div>
            </div>
          )}
        </div>
      </div>
    )}
  </div>

  <button type="submit" className="submit-btn-design">Search</button>
</form>


          )}

          {activeTab === 'hotel' && (
          <form className="booking-form" onSubmit={handlehotelSubmit}>
{/* City Dropdown */}
<select value={location} onChange={(e) => setLocation(e.target.value)}>
  <option value="">Select City</option>
  {cities.map((city, i) => (
    <option key={i} value={city.code}>{city.name}</option>
  ))}
</select>

{/* Hotel Dropdown */}
<select value={hotelName} onChange={(e) => setHotelName(e.target.value)}>
  <option value="">Select Hotel</option>
  {hotels.map((hotel, i) => (
    <option key={i} value={hotel.code}>{hotel.name}</option>
  ))}
</select>



     <div> 
      <label>Check-in Date</label>
      <br/>
  <input
    type="date"
    value={checkIn}
    onChange={(e) => setCheckIn(e.target.value)}
  />
</div>
<div>
<label>Check-out Date</label>
<br/>
  <input
    type="date"
    value={checkOut}
    onChange={(e) => setCheckOut(e.target.value)}
  />
  </div>

  <div className="room-selector">
    <button type="button" onClick={() => setShowRoomSelector(!showRoomSelector)}>
      {rooms.length} Room, {totalGuests} Guests
    </button>

    {showRoomSelector && (
      <div className="room-dropdown">
        {rooms.map((room, index) => (
          <div key={index}>
            <h4>Room {index + 1}</h4>
            <label>Adult:</label>
            <select
              value={room.adults}
              onChange={(e) => handleRoomChange(index, 'adults', e.target.value)}
            >
              {[1, 2, 3, 4].map((num) => (
                <option key={num}>{num}</option>
              ))}
            </select>

            <label>Child:</label>
            <select
              value={room.children}
              onChange={(e) => handleRoomChange(index, 'children', e.target.value)}
            >
              {[0, 1, 2, 3].map((num) => (
                <option key={num}>{num}</option>
              ))}
            </select>

            {room.childAges.map((age, ageIndex) => (
              <div key={ageIndex}>
                <label>Child {ageIndex + 1} Age:</label>
                <select
                  value={age}
                  onChange={(e) =>
                    handleChildAgeChange(index, ageIndex, e.target.value)
                  }
                >
                  {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((a) => (
                    <option key={a}>{a}</option>
                  ))}
                </select>
              </div>
            ))}
          </div>
        ))}

        <button type="button" onClick={handleAddRoom}>+ Add Room</button>
        <button type="button" onClick={() => setShowRoomSelector(false)}>Apply</button>
      </div>
    )}
  </div>

  <button className="search-button" type="submit">
    Search
  </button>
</form>

          )}

          {activeTab === 'holiday' && (
            <div className="modify_form home_form">
    <form
      onSubmit={handleSearch}
      onReset={() => {
        setSelectedCountry(''); // Reset country instead of city
      }}
    >
      <div className="form-group-floating">
        <select
          required
          className="form-control custom-select"
          value={selectedCountry}
          onChange={(e) => setSelectedCountry(e.target.value)}
        >
          <option value="" disabled hidden>Select Country</option>
          {countryOptions.length > 0 ? (
            countryOptions.map((country, idx) => (
              <option key={idx} value={country}>{country}</option>
            ))
          ) : (
            <option disabled>Loading countries...</option>
          )}
        </select>
        <label>Destination</label>
      </div>

                {/* Month Select */}
                <div className="form-group-floating">
                  <select
                    
                    className="form-control custom-select"
                    value={selectedMonth}
                    onChange={(e) => setSelectedMonth(e.target.value)}
                  >
                    <option value="" disabled hidden>Select Month</option>
                    {Object.keys(monthNameToNumber).map((month) => (
                      <option key={month} value={month}>{month}</option>
                    ))}
                  </select>
                  <label>Month</label>
                </div>

                {/* Buttons */}
                <div className="form-buttons">
                  <button type="submit" style={styles.submitBtn}>Search</button>
                 
                </div>
              </form>
            </div>

          )}
        </div>
      </div>

      <div className="marquee">
        <div className="marquee-content">
          <span>
            🚀 {Info.info_text || "Loading..."} ✈️🏖️
          </span>
          
        </div>
      </div>





      
<div className="package_slider">
  <h2 className="holiday">Holiday Packages</h2>

  <Slider {...sliderSettings}>
    {packages
      .filter(pkg => pkg.for_home)
      .map(pkg => {

        // ==========================================
        // GET DOUBLE ROOM ADULT PRICE
        // ==========================================
        let doublePrice = 0;

        try {
          const hotelRatings = pkg.hotel_ratings || [];
          const firstHotel = hotelRatings[0];

          const doubleRoom = firstHotel?.room_types?.find(
            rt => rt.room_type === "Double"
          );

          doublePrice = parseInt(
            doubleRoom?.adults?.replace(/[^0-9]/g, "") || "0",
            10
          );

        } catch (e) {
          console.error("Hotel pricing parse error:", e);
        }

        return (
          <div key={pkg.id}>

            <Link
              to={`/packages/${pkg.id}?flight=0`}
              style={{
                textDecoration: "none",
                color: "inherit"
              }}
            >

              <div
                className="mtst"
                style={{
                  border: "1px solid #ccc",
                  padding: "16px",
                  borderRadius: "10px",
                  background: "#fff",
                  boxShadow: "0 0 8px rgba(0,0,0,0.1)"
                }}
              >

                {/* PACKAGE IMAGE */}
                {pkg.images?.length > 0 && (
                  <img
                    className="package_slider_image"
                    src={`https://online.funforay.com/admin/storage/app/public/${pkg.images[0]}`}
                    alt={pkg.title}
                    style={{
                      width: "100%",
                      height: "180px",
                      objectFit: "cover",
                      borderRadius: "8px"
                    }}
                  />
                )}

                {/* PACKAGE TITLE */}
                <h3 className="price">
                  {pkg.title}
                </h3>

                {/* CITIES */}
                <div className="cities_box">

                  <img
                    src="/images/Container.png"
                    alt="Cities Icon"
                  />

                  <p className="cities">
                    {(() => {
                      try {
                        const cities = JSON.parse(pkg.city_name);

                        return Array.isArray(cities)
                          ? cities.join(", ")
                          : pkg.city_name;

                      } catch {
                        return pkg.city_name;
                      }
                    })()}
                  </p>

                </div>

                {/* WITHOUT FLIGHT PRICE */}
                {doublePrice > 0 && (
                  <p className="rsign">

                    <img
                      src="/images/ruppe.png"
                      alt="rupee"
                      style={{
                        width: "14px"
                      }}
                    />

                    ₹{doublePrice.toLocaleString("en-IN")}
                    {" "}Per Person

                  </p>
                )}

                {/* BOOK WIDGETS */}
                <div className="book_widgets">

                  {/* DURATION */}
                  <div className="days">

                    <img
                      src="/images/Container1.png"
                      alt=""
                    />

                    <p className="duration_home">
                      {pkg.duration}N /{" "}
                      {Number(pkg.duration) + 1}D
                    </p>

                  </div>

                  {/* BOOK NOW */}
                  <button
                    type="button"
                    className="btn book_package"
                    onClick={(e) => {
                      e.preventDefault();
                      window.location.href =
                        `/packages/${pkg.id}?flight=0`;
                    }}
                  >
                    Book now

                    <img
                      src="/images/Vector.png"
                      alt=""
                    />
                  </button>

                </div>

              </div>

            </Link>

          </div>
        );
      })}
  </Slider>
</div>

      <RecentGallery />

     <section className='client_logos'>
      <Slider
        dots={false}
        infinite={true}
        slidesToShow={5}
        slidesToScroll={1}
        autoplay={true}
        autoplaySpeed={1500}
        arrows={false}
        pauseOnHover={false}
        responsive={[
          { breakpoint: 1024, settings: { slidesToShow: 4 } },
          { breakpoint: 768, settings: { slidesToShow: 2 } },
          { breakpoint: 480, settings: { slidesToShow: 1 } }
        ]}
      >
        {logos.map((logo) => (
          <div key={logo.id}>
            <img src={logo.image} alt="Client Logo" />
          </div>
        ))}
      </Slider>
    </section>
    </main>
  );
}

const styles = {
  formField: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 200px',
  },
  submitBtn: {
    padding: '10px 20px',
    backgroundColor: '#EA028F',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '21px',
    whiteSpace: 'nowrap',
    textTransform: 'uppercase',
    fontWeight: '800',
  },
}

function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/packages" element={<Packages />} />
         <Route path="/flights" element={<Flights />} />
        <Route path="/packages/:id" element={<PackageDetails />} />
        <Route to="/api/search-flights">Search</Route> 
        <Route path="/hotels" element={<HotelResults />} />
         <Route path="/hotel-result" element={<HotelResults />} />
         <Route path="/book-flight" element={<BookingPage />} />
         
          <Route path="/contact" element={<Contact />} />
           <Route path="/privacy-policy" element={<PrivacyPolicy />} />
           <Route path="/terms-conditions" element={<TermsConditions />} />
           <Route path="/user-agreement" element={<UserAgreement />} />

           <Route path="/booking" element={<Booking />} />
            <Route path="/login" element={<Login />} />
            <Route path="/package-booking" element={<PackageBooking />} />
      <Route path="/register"  element={<Register />}
       />
       <Route path="/gallery" element={<Gallery />} />
      <Route
        path="/profile"
        element={
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        }
      />
     
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
